module.exports = __webpack_public_path__ + "img/10.7532ba2f.png";